/**
 * Store admin — collections list (Commerce, M6).
 * @see prototype/store/admin/all.html#collections-list
 */
import { createFileRoute } from "@tanstack/react-router";
import { CollectionsListPage } from "../../../../../features/store/collections/collections-list-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/collections/")({
  component: CollectionsListPage,
});
